<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4>Αλλαγή Email και Password</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-md-offset-3 form-container">
        <form
          class="forms-style"
          @submit.prevent="onSubmit"
          autocomplete="off"
          v-if="user != null"
        >
          <div class="panel-heading">Γενικά στοιχεία</div>

          <div class="panel panel-primary">
            <div class="panel-body">
              <alert-box :alerts="alerts" v-if="alerts.length > 0"></alert-box>

              <div class="form-group">
                <label for="FirstName">Ονομα</label>
                <input
                  class="form-field"
                  type="text"
                  id="FirstName"
                  v-model="user.FirstName"
                  v-focus
                  placeholder="Ονομα"
                  readonly
                />
              </div>
              <div class="form-group">
                <label for="LastName">Επίθετο</label>
                <input
                  class="form-field"
                  type="text"
                  id="LastName"
                  v-model="user.LastName"
                  v-focus
                  placeholder="Επίθετο"
                  readonly
                />
              </div>
              <div class="form-group">
                <label for="Email">Email</label>
                <input
                  class="form-field"
                  type="email"
                  id="Email"
                  v-model="user.Email"
                  v-focus
                  placeholder="Email"
                />
              </div>

              <div class="form-group">
                <label for="Password">Password</label>
                <input
                  class="form-field"
                  type="Password"
                  id="Password"
                  v-model="user.Password"
                  v-focus
                  placeholder="Password"
                  required
                />
              </div>

              <div class="form-group">
                <label for="PasswordConfirm">Επαλήθευση Password</label>
                <input
                  class="form-field"
                  type="Password"
                  id="PasswordConfirm"
                  v-model="user.PasswordConfirm"
                  v-focus
                  placeholder="Password"
                  required
                />
              </div>

              <div v-if="user.AreaId == 3" class="form-group">
                <label for="IsMobileUser">Χρήστης Κινητού</label>
                <input
                  class=""
                  type="checkbox"
                  id="IsMobileUser"
                  v-model="user.IsMobileUser"
                />
              </div>

              <div v-if="user.AreaId == 3" class="form-group">
                <label for="MobilePin">Pin</label>
                <input
                  class="form-field"
                  type="Password"
                  id="MobilePin"
                  placeholder="Pin"
                  :disabled="!user.IsMobileUser"
                  v-model="user.MobilePin"
                  v-focus
                />
              </div>
              <!-- <a
                v-if="
                  !user.IsEmailValid &&
                  user.Email != '' &&
                  emailOld == user.Email
                "
                class="col-md-offset-4 col-md-8"
                style="margin-bottom: 10px; text-align: right; cursor: pointer"
                @click="resendConfirmationEmail"
                >Επαναποστολή Email Επιβεβαίωσης</a
              > -->
              <button
                type="button"
                @click="save"
                :disabled="user.Password == '' && user.Email == ''"
              >
                Αλλαγή
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import mainService from "../../services/mainService";
import BackButton from "../shared/backButton";
import notify from "devextreme/ui/notify";
import AlertBox from "../shared/alertBox.vue";

export default {
  components: {
    BackButton,
    AlertBox,
  },
  data(AlertBox) {
    return {
      user: null,
      emailOld: "",
      errorMessage: "",
      alerts: [],
    };
  },
  computed: {},
  methods: {
    async save() {
      this.alerts = [];
      debugger;
      if (this.user.Password != "" && this.user.PasswordConfirm == "") {
        this.alerts.push(
          "Για να αλλάξετε Password θα πρέπει να συμπληρώσετε και την Επαλήθευση Password"
        );
        return false;
      }
      if (!this.validEmail(this.user.Email)) {
        this.alerts.push(
          "Το email δεν είναι έγκυρο. Εισάγετε σωστό email (π.χ. default@test.gr)"
        );
      }
      const res = await mainService.post("/Users/UpdatePartOfUser", this.user);
      if (
        res.data.Message == null ||
        res.data.Message == "" ||
        res.data.Message == "OK"
      ) {
        this.user.Password = "";
        this.user.PasswordConfirm = "";
        notify("H αλλαγή στοιχείων έγινε επιτυχώς", "success", 1000);
      } else {
        this.alerts.push(res.data.Message);
      }
    },
    async resendConfirmationEmail() {
      const res = await mainService.post(
        "/Users/ResendConfirmationEmail",
        this.user
      );
      debugger;
      if (res.data.mailResponse != "OK")
        notify(res.data.mailResponse, "error", 5000);
      else
        notify(
          "Το email ενεργοποίησης στάλθηκε ξανά στο " + res.data.user.Email,
          "success",
          5000
        );
    },
    validEmail(email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
  async mounted() {
    const res = await mainService.get(`/Users/GetUser`);
    this.user = res.data;
    this.emailOld = res.data.Email;
  },
};
</script>
<style lang="scss" scoped>
.forms-style {
  label {
    width: 170px;
  }
}
input[type="checkbox"] {
  margin: 1px 0 0 5px;
  width: 40px;
  height: 40px;
}
</style>